import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const CheckCircleIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 16} height={size || 17} viewBox="0 0 16 17" fill="none" {...rest}>
        <g clipPath="url(#clip0)">
            <path
                d="M.5 8.5a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0Z"
                fill="currentColor"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="m4 9.315 1.633 2.318a.7.7 0 0 0 1.138.034L12 5.052"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </Svg>
);
